var React = require('react');

function FacebookBrandsIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.9,9l.444-2.9H28.564V4.225A1.448,1.448,0,0,1,30.2,2.661h1.263V.2A15.4,15.4,0,0,0,29.217,0a3.535,3.535,0,0,0-3.784,3.9V6.1H22.89V9h2.543v7h3.13V9Z","transform":"translate(-22.89)","fill":"#fff"}));
}

FacebookBrandsIcon.defaultProps = {"width":"8.569","height":"16","viewBox":"0 0 8.569 16"};

module.exports = FacebookBrandsIcon;

FacebookBrandsIcon.default = FacebookBrandsIcon;
